import closest from '@mailobj-browser/front/js/selectors/closest.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import replaceChildren from '@mailobj-browser/front/js/tree/replaceChildren.js'
import sse, { release } from '@mailobj-browser/front/js/sse/sse.js'
import progress from '@mailobj-browser/front/js/events/types/progress.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'

const { parse } = JSON
const { parseInt } = Number
const elements = new Map()
const fieldsets = new WeakMap()

const onProgress = object(listener, {
  passive,
  type: progress,
  task: async (source, { data }) => {
    const { key, uid, value = 0 } = parse(data)
    
    if (!elements.has(uid)) {
      return
    }
    
    const progresses = elements.get(uid)
    const progress = progresses.get(key)
    let fieldset = fieldsets.get(progress)
    
    if (value === 100) {
      progresses.delete(key)
      
      if (fieldset.contains(progress)) {
        while (true) {
          if (fieldset && !one('input[type="file"]:not(:disabled)', fieldset)) {
            fieldset.disabled = true
            fieldset = closest('fieldset', fieldset)
            
            continue
          }
          
          break
        }
      }
      
      if (!progress.size) {
        elements.delete(uid)
        release(source, uid)
      }
    }
    
    progress.setAttribute('value', value)
    replaceChildren(progress, `${value}%`)
  }
})

export default (form, body, url, inputs) => {
  const { source, uid } = sse(url)
  const progresses = new Map()
  const { dataset } = form
  const { sseEvent } = dataset
  
  body.set('PHP_SESSION_UPLOAD_PROGRESS', `${uid}`)
  body.set('ea_event', sseEvent)
  
  for (const input of inputs) {
    const { name } = input
    const [, key] = name.match(/\[(\d+)]/)
    const fieldset = closest('fieldset', input)
    const progress = one('progress', fieldset)
    
    fieldsets.set(progress, fieldset)
    progresses.set(parseInt(key, 10), progress)
  }
  
  elements.set(uid, progresses)
  onProgress.listen(source)
}
